module.exports = __webpack_public_path__ + "img/5.de7e1102.svg";